<div class="main_content">
    <app-breadcrumb></app-breadcrumb>
    <div #page_section class="page_main_sec">
        <div class="OpenSearch_main_sec">
            <!-- title bar section Start-->
            <div class="container-fluid">
                <!-- <div class="post-nav-wrap">
                    <div class="title-wrap">
                        <p class="title">Unlock Invoice</p>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- advance Search section Start-->
        <div class="tab-content">

            <!-- Table View -->
            <div class="table_card_sec mb_0">
                <div class="table scroll_table">
                    <div class="row advance-search-wrp">
                        <div class="col-lg-3">
                            <app-dropdown-multiselect #ddlDocselect [lstDropdownOption]="docTypeList"
                                [labelText]="'Work Item Type'" [isMandetory]="1" [allSelected]="true">
                            </app-dropdown-multiselect>
                            <!-- <mat-form-field appearance="legacy" [style.width.%]="100">
                                <mat-label>Work Item Type
                                    <span class="field-mandatory">*</span>
                                </mat-label>
                                <mat-select [(ngModel)]="selectedDocumentType"
                                    (selectionChange)="onSelectDocumentType()">
                                    <mat-option [value]="doc.value" *ngFor="let doc of docTypeList">
                                        {{doc.text}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field> -->

                        </div>
                        <div class="col-lg-3">
                            <mat-form-field [style.width.%]="100">
                                <mat-label for="txtURN">URN </mat-label>
                                <input matInput id="txtURN" [(ngModel)]="strURN" placeholder="URN" maxlength="30">

                            </mat-form-field>
                        </div>
                        <div class="col-lg-3">
                            <mat-form-field [style.width.%]="100">

                                <mat-date-range-input [rangePicker]="workitempicker"
                                    [formGroup]="workItemCreationDateRange" [attr.role]="null">
                                    <input matStartDate formControlName="work_item_start_date" #workitemstartdate
                                        placeholder="Start Date" [max]="maxDate"
                                        (dateChange)="onWorkItemCreationDateChanges()" readonly>
                                    <input matEndDate formControlName="work_item_end_date" title="End Date"
                                        #workitemendDate placeholder="End Date" [max]="maxDate"
                                        (dateChange)="onWorkItemCreationDateChanges()" readonly>
                                </mat-date-range-input>
                                <mat-label>Work Item Creation Date Range</mat-label>
                                <button *ngIf="isWorkItemDateRangeHasValue" mat-button matSuffix mat-icon-button
                                    (click)="resetWorkItemCreationDateRange()">
                                    <mat-icon [attr.role]="null">clear</mat-icon>
                                </button>
                                <mat-datepicker-toggle matSuffix [for]="workitempicker"></mat-datepicker-toggle>
                                <mat-date-range-picker #workitempicker></mat-date-range-picker>
                            </mat-form-field>

                        </div>
                        <div class="col-lg-3">
                            <mat-form-field [style.width.%]="100">
                                <mat-date-range-input [rangePicker]="picker" [attr.role]="null"
                                    [formGroup]="invoiceCreationDateRange">
                                    <input matStartDate formControlName="start_date" #startdate placeholder="Start Date"
                                        [max]="maxDate" (dateChange)="onInvoiceCreationDateChanges()" readonly>
                                    <input matEndDate formControlName="end_date" title="End Date" #endDate
                                        placeholder="End Date" [max]="maxDate"
                                        (dateChange)="onInvoiceCreationDateChanges()" readonly>
                                </mat-date-range-input>
                                <mat-label>Idea Creation Date Range</mat-label>
                                <button *ngIf="isDateRangeHasValue" mat-button matSuffix mat-icon-button
                                    (click)="resetInvoiceCreationDateRange()">
                                    <mat-icon [attr.role]="null">clear</mat-icon>
                                </button>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>


                        </div>
                        <div class="col-lg-3">
                            <!-- <mat-form-field appearance="legacy" [style.width.%]="100">
                                <mat-label>Process
                                </mat-label>
                                <mat-select [(ngModel)]="selectedProcessType">
                                    <mat-option [value]="doc.value" *ngFor="let doc of processTypeList">
                                        {{doc.text}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field> -->
                            <app-dropdown-multiselect #ddlProcessmultiselect [labelText]="'Queue'" [isMandetory]="1"
                                [lstDropdownOption]="processTypeList" [allSelected]="true">
                            </app-dropdown-multiselect>
                        </div>
                        <div class="col-lg-9 text-end" [style.line-height]="4">
                            <button type="button" class="btncss me-2 btn_primary" (click)="getLockedURNs();">
                                Search
                            </button>
                            <button type="button" class="btncss me-2 btn_secondary" (click)="clearOpenSearch()">
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- [advanceSearchFields]="advanceSearchDynamicFields" -->
                <div *ngIf="isDisplayTransactionData" class="row selection-sec">
                    <app-advance-gridview [lstData]="lstURNData" [lstHeaders]="lstHeaders" #gridTransactionData
                        [gridTitle]="'Locked URNs'" [showColumnGroup]="false" [showAdvanceSearchOption]="true"
                        [showExcelDownloadOption]="true" (cellClickEvent)="cellClickEvent($event)"
                        (advanceSearchClickEvent)="advanceSearchClickEvent($event)"
                        (columnsFilterChangeEvent)="columnsFilterChangeEvent($event)">
                    </app-advance-gridview>
                </div>
            </div>

            <div class="tab-content" *ngIf="isDataFound">
                <div class="table_card_sec mb_0">
                    <div class="text-center">
                        <button type="button" class="btncss me-2 btn_primary"
                            (click)="showModal(invoiceSubmittedModal);">
                            Unlock Selected URNs
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #invoiceSubmittedModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Alert</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')" title="Close">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                Are you sure you want to unlock selected URNs?
            </div>
            <div class="model_center_btn_part">
                <button type="button" class="model_ok_btn me-2" (click)="modalReference.close();unlockInvoices();">
                    Yes
                </button>
                <button type="button" class="model_cancle_btn me-2" (click)="modalReference.close()">
                    No
                </button>
            </div>
        </div>
    </div>
</ng-template>

<app-transaction-lite></app-transaction-lite>